import mapFromDialogToSnippet from "utils/helpers/mapFromDialogToSnippet";
import {stubTrue, uniq as uniqIdSelectedMsg} from 'lodash'

import {
  actionTypes,
  dialogType,
  foldersIds,
  folderType,
  messageType,
  previewUserInfo, snippetType,
  systemMessageTypes,
} from "./messagesTypes";

const idFolderAll: number = -1
let updateSnippets: snippetType[] = []

const initialState: messagesStateType = {
  folders: [],
  dialogs: {
    '-1': [],
    '-2': [],
    '-3': [],
    '-4': []
  },
  currentMessages: [],
  isLoading: false,
  isLoadingMore: false,
  isLoadingDialogs: false,
  currentUser: {} as previewUserInfo,
  editingMessage: {} as messageType,
  // Ответ (reply) как в приле: сообщение, на которое отвечаем.
  replyingMessage: {} as messageType,
  errorMessages: {
    messagesId: []
  },
  idSelectedMessages: [],
  endOfMessages: false,
  archive: [],
  blackList: [],
  allDialogs: [],
  isNewMsgReceived: false,
  snippets: [],
  msgCounter: 0,
  folderId: foldersIds.all,
  isOpenMessages: false,
  enteredMsgText: {},
  isLoadingSnippet: false,
  isResetMsgText: false,
  dates: []
};

type messagesStateType = {
  folders: Array<folderType>;
  dialogs: {[key: number]: Array<dialogType>};
  currentMessages: Array<messageType>;
  isLoading: boolean;
  isLoadingMore: boolean;
  isLoadingDialogs: boolean;
  currentUser: previewUserInfo;
  editingMessage: messageType;
  replyingMessage: messageType;
  errorMessages: {
    messagesId: number[]
  };
  idSelectedMessages: Array<number>;
  endOfMessages: boolean;
  archive: Array<dialogType>;
  blackList: Array<dialogType>;
  allDialogs: Array<dialogType>;
  isNewMsgReceived: boolean;
  isOpenMessages: boolean;
  snippets: Array<any>;
  msgCounter: number;
  folderId: number;
  enteredMsgText: {[key: number]: string};
  isLoadingSnippet: boolean;
  isResetMsgText: boolean;
  dates: string[];
};

const messagesReducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case actionTypes.SET_FOLDERS:
      return {
        ...state,
        folders: [...payload],
      };
    case actionTypes.SET_DIALOGS:
      const {dialogs: dialogsInFolder, folderId} = payload
      return {
        ...state,
        dialogs: {
          ...state.dialogs,
          [folderId]: dialogsInFolder
        },
      };
    case actionTypes.SET_MESSAGES:
      return {
        ...state,
        currentMessages: [...payload],
      };
    case actionTypes.RESET_MESSAGES:
      return {
        ...state,
        currentMessages: payload,
      };
    case actionTypes.SET_MESSAGES_MORE:
      return {
        ...state,
        currentMessages: [...payload, ...state.currentMessages],
      };
    case actionTypes.SET_MSG_LOADING:
      return {
        ...state,
        isLoading: payload,
      };
    case actionTypes.SET_MSG_LOADING_MORE:
      return {
        ...state,
        isLoadingMore: payload,
      };
    case actionTypes.SET_USER_PREVIEW:
      return {
        ...state,
        currentUser: payload,
      };
    case actionTypes.SET_EDITING_MESSAGE:
      const cloneCurrentMessages = JSON.parse(JSON.stringify(state.currentMessages))
      const editingMessage = cloneCurrentMessages.find((el: messageType) => el.id === payload)

      return {
        ...state,
        editingMessage: editingMessage,
        // Редактирование и ответ взаимоисключающие (как в приле).
        replyingMessage: {} as messageType,
      };
    case actionTypes.SET_REPLYING_MESSAGE:
      // В приле ответ во время редактирования игнорируется.
      if (state.editingMessage?.id) return state;
      return {
        ...state,
        replyingMessage: payload || ({} as messageType),
      };
    case actionTypes.DELETE_MESSAGE: {
      const delId = Number(payload);
      return {
        ...state,
        currentMessages: state.currentMessages.filter((m) => Number(m.id) !== delId),
        editingMessage: Number(state.editingMessage?.id) === delId ? ({} as messageType) : state.editingMessage,
        replyingMessage: Number(state.replyingMessage?.id) === delId ? ({} as messageType) : state.replyingMessage,
      };
    }
    case actionTypes.RESET_REPLYING_MESSAGE:
      if (!state.replyingMessage?.id) return state;
      return {
        ...state,
        replyingMessage: {} as messageType,
      };
    case actionTypes.RESET_EDIT_MESSAGE:
      return {
        ...state,
        editingMessage: {}
      }
    case actionTypes.REPLACE_EDIT_MESSAGE:
      const {idMsg, newText} = payload
      const currentMessages = state.currentMessages.map(msg => {
        if (msg.id === +idMsg) {
          msg.text = newText;
          msg.edit = true
          return msg
        } else {
          return msg
        }
      })
      return {
        ...state, currentMessages
      }
    case actionTypes.SET_ID_SELECTED_MESSAGES:
      return {
        ...state,
        idSelectedMessages: uniqIdSelectedMsg([...state.idSelectedMessages, ...payload])
      }
    case actionTypes.REPLACE_ID_SELECTED_MESSAGES:
      const idSelectedMessages = payload.idMsg ? [...state.idSelectedMessages].filter(id => id !== payload.idMsg) : []
      return {
        ...state,
        idSelectedMessages
      }
    case actionTypes.RESET_ID_SELECTED_MESSAGES:
      return {...state, idSelectedMessages: []}
    case actionTypes.RESET_CURRENT_USER:
      return {
        ...state,
        currentUser: payload,
      };
    case actionTypes.SET_END_OF_MESSAGES:
      return {
        ...state,
        endOfMessages: payload,
      };
    case actionTypes.ADD_NEW_MSG:
      if (
        (state.currentUser.id === payload.idSender ||
        state.currentUser.id === payload.idRecipient) && 
        payload.systemMessageType === systemMessageTypes.ban
      ) {
        const shiftedMsgsAfterSend = [...state.currentMessages, payload]
        if (state.currentMessages.length >= 50) {
          shiftedMsgsAfterSend.shift() 
        }
        return {
          ...state,
          currentMessages: shiftedMsgsAfterSend,
          currentUser: {
            ...state.currentUser,
            isMeBlocked: true
          }
        };
      } else if (
        state.currentUser.id === payload.idSender ||
        state.currentUser.id === payload.idRecipient
      ) {
        const shiftedMsgsAfterSend = [...state.currentMessages, payload]
        if (state.currentMessages.length >= 50) {
          shiftedMsgsAfterSend.shift() 
        }
        return {
          ...state,
          currentMessages: shiftedMsgsAfterSend,
        };
      } else {
        return state;
      }
    case actionTypes.SET_MSG_DELIVERED:
      const tempMessages = [...state.currentMessages];
      const indexDelivered = tempMessages.findIndex(
        (el) => el.id === payload.tempId
      );
      if (tempMessages[indexDelivered]) {
        // новый объект (а не мутация) — чтобы снялся лоадер «фото грузится»
        tempMessages[indexDelivered] = {
          ...tempMessages[indexDelivered],
          id: payload.realId,
          readStatus: false,
          pending: false,
        };
      }
      return {
        ...state,
        currentMessages: tempMessages,
      };
    case actionTypes.SET_MSG_NOT_DELIVERED:
      // Как в приле (rejected SEND_MESSAGE): бэк отклонил отправку (нет
      // премиума/контактов/верификации и т.п.) — убираем оптимистично
      // добавленное сообщение из чата, а не оставляем «якобы отправленным».
      return {
        ...state,
        currentMessages: state.currentMessages.filter((el) => el.id !== payload),
      };
    case actionTypes.SET_MSGS_READED:
      const readedMessages = [...state.currentMessages].map((el) => {
        if (payload.findIndex((elem: number) => elem === el.id) >= 0) {
          return {
            ...el,
            readStatus: true,
          };
        } else {
          return el;
        }
      });
      return {
        ...state,
        currentMessages: readedMessages,
      };
    case actionTypes.SET_BLACK_LIST:
      return {
        ...state,
        blackList: payload,
      };
    case actionTypes.SET_ALL_DIALOGS:
      return {
        ...state,
        allDialogs: payload,
      };
    case actionTypes.ADD_NEW_DIALOG:
      const idxAllFolder = '-1'
      const pushedAllDialog = [...state.dialogs[state.folderId]];
      pushedAllDialog.unshift(payload);
      const pushedNewSnippets = mapFromDialogToSnippet(pushedAllDialog);
      return {
        ...state,
        dialogs: {
          ...state.dialogs,
          [idxAllFolder]: pushedAllDialog
        },
        snippets: pushedNewSnippets
      };
    case actionTypes.REMOVE_NEW_DIALOG: {
      const allKey = '-1';
      const allDialogs = [...(state.dialogs[allKey] || [])].filter((d: any) => d.id !== payload);
      return {
        ...state,
        dialogs: {
          ...state.dialogs,
          [allKey]: allDialogs,
          ...(String(state.folderId) !== allKey && state.dialogs[state.folderId]
            ? { [state.folderId]: [...state.dialogs[state.folderId]].filter((d: any) => d.id !== payload) }
            : {}),
        },
        snippets: mapFromDialogToSnippet(allDialogs),
      };
    }
    case actionTypes.UPDATE_FOLDERS_COUNTERS_REALTIME:
      const tempFolders = state.folders && JSON.parse(JSON.stringify(state.folders));

      for (let key in payload) {
        const tempIndex = tempFolders.findIndex((el: folderType) => el.folder.id === Number(key));
        tempIndex > -1 && (tempFolders[tempIndex].unreadMessage = payload[key]);
      }

      if (state.currentUser.id) {
        const idFoldersHaveCurrentDialog = [...state.dialogs[state.folderId]].find(dialog => dialog.id === state.currentUser.id)
            ?.folderExists.filter(idFolder => idFolder !== idFolderAll)

        idFoldersHaveCurrentDialog?.forEach(idFolder => {
          const idxNeedFolderInArray = tempFolders.findIndex((el: folderType) => el.folder.id == idFolder)
          // @ts-ignore
          tempFolders[idxNeedFolderInArray].unreadMessage = tempFolders[idxNeedFolderInArray].unreadMessage - 1 // -1 это то смс которое пришло сейчас (в realtime)
        })
      }

      return {
        ...state,
        folders: tempFolders,
      };

    case actionTypes.UPDATE_FOLDERS_COUNTERS_OPEN_CONVERSATION:
      const cloneFolders = state.folders && JSON.parse(JSON.stringify(state.folders));

      const cntUnreadMsgOnCurrentDialogs = [...state.dialogs[state.folderId]].find(dialog => dialog.id === payload.id)?.countUnreadMessages
      const idFoldersHaveCurrentDialog = [...state.dialogs[state.folderId]].find(dialog => dialog.id === payload.id)
          ?.folderExists.filter(idFolder => idFolder !== idFolderAll)

      idFoldersHaveCurrentDialog?.forEach(idFolder => {
        const idxNeedFolderInArray = cloneFolders.findIndex((el: folderType) => el.folder.id == idFolder)
        // @ts-ignore
        cloneFolders[idxNeedFolderInArray].unreadMessage = cloneFolders[idxNeedFolderInArray].unreadMessage - cntUnreadMsgOnCurrentDialogs
      })

      return {
        ...state,
        folders: cloneFolders,
      };

    case actionTypes.SET_IS_NEW_MSG_RECEIVED:
      return {
        ...state,
        isNewMsgReceived: payload,
      };
    case actionTypes.SET_IS_ONLINE:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          isOnline: payload,
        },
      };
    case actionTypes.SET_MSG_SNIPPETS:
      return {
        ...state,
        snippets: payload,
      };
    case actionTypes.SET_MSG_REALTIME_SNIPPETS:
      const idUserAtNewSnippet = payload.previewUser.previewUserInfo.id
      const cloneSnippets = JSON.parse(JSON.stringify(state.snippets))
      const idxElWithIdNewSnippet = cloneSnippets.findIndex((snippet: snippetType) => snippet.previewUser.previewUserInfo.id === idUserAtNewSnippet)

      if(idxElWithIdNewSnippet > -1) {
        cloneSnippets.splice(idxElWithIdNewSnippet, 1, payload)

        updateSnippets = [cloneSnippets[idxElWithIdNewSnippet], ...cloneSnippets.filter((el: snippetType, idx: number) => idx !== idxElWithIdNewSnippet)]
      } else {
        if (cloneSnippets.length > 2) {
          updateSnippets = cloneSnippets.splice(0, 1, payload)
        } else {
          updateSnippets = [payload, ...cloneSnippets]
        }
      }

      return {
        ...state,
        snippets: updateSnippets.slice(0,3),
      };
    case actionTypes.EDITED_TEXT_SNIPPET_MESSAGE:
      const idxSnippetWithEditedText = state.snippets.findIndex((snippet: snippetType) => snippet.previewUser.previewUserInfo.id === payload.idRecipient)
      updateSnippets = state.snippets.map((snippet: snippetType, idx: number) => {
        if (idx === idxSnippetWithEditedText) {
          return {
            ...snippet,
            lastMessage: {
              ...snippet.lastMessage, text: payload.editedMsgText
            }
          }
        } else {
          return snippet
        }
      })

      return {
        ...state,
        snippets: updateSnippets
      }
    case actionTypes.SET_MSG_COUNTER:
      if (Array.isArray(state.folders) && state.folders.length) {
        const tempFolders = [...state.folders];
        tempFolders[0].unreadMessage = payload;
        return {
          ...state,
          folders: tempFolders,
        };
      } else {
        return {
          ...state,
          folders: [{ folder: {}, unreadMessage: payload }, ...state.folders],
        };
      }
    case actionTypes.REDUCE_MSG_COUNTER:
      if (Array.isArray(state.folders) && state.folders.length) {
        const tempFolders = JSON.parse(JSON.stringify(state.folders)) // Было [...state.folders]
        const tempCounter = tempFolders[0].unreadMessage! - payload;

        const idCurrentDialog = state.currentUser.id
        const tempDialogs = JSON.parse(JSON.stringify(state.dialogs[state.folderId])).map((dialog: dialogType) => {
          if (dialog.id === idCurrentDialog ) {
            return {
              ...dialog, countUnreadMessages: 0
            }
          } else {
            return dialog
          }
        })

        if (tempCounter < 0) {
          tempFolders[0].unreadMessage = 0;
        } else {
          tempFolders[0].unreadMessage = tempCounter;
        }

        return {
          ...state,
          folders: tempFolders,
          dialogs: {
            ...state.dialogs,
            [state.folderId]: tempDialogs
          }
        };
      } else {
        return state
      }
    case actionTypes.DELETE_CHAT_FROM_DIALOGS:
      const dialogsBeforeDeleting = [...state.dialogs[state.folderId]];
      const snippetsBeforeDeleting = [...state.snippets];
      const indexOfDeletingDialog = dialogsBeforeDeleting.findIndex((el) => el.previewUserInfo.id === payload);
      const indexOfDeletingSnippet = snippetsBeforeDeleting.findIndex((el: any) => el.previewUser.previewUserInfo.id === payload);
      if (indexOfDeletingDialog < 0 && indexOfDeletingSnippet < 0) {
        return state
      } else if (indexOfDeletingDialog >= 0 && indexOfDeletingSnippet >= 0) {
        dialogsBeforeDeleting.splice(indexOfDeletingDialog, 1);
        snippetsBeforeDeleting.splice(indexOfDeletingSnippet, 1);
        return {
          ...state,
          dialogs: {
            ...state.dialogs,
            [state.folderId]: dialogsBeforeDeleting
          },
          snippets: snippetsBeforeDeleting
        }
      } else if (indexOfDeletingDialog >= 0 && indexOfDeletingSnippet < 0) {
        dialogsBeforeDeleting.splice(indexOfDeletingDialog, 1);
        return {
          ...state,
          dialogs: {
            ...state.dialogs,
            [state.folderId]: dialogsBeforeDeleting
          },
        }
      } else {
        snippetsBeforeDeleting.splice(indexOfDeletingSnippet, 1);
        return {
          ...state,
          snippets: snippetsBeforeDeleting
        }
      }
    case actionTypes.UPDATE_DIALOG:
      const updatingDialogs = JSON.parse(JSON.stringify(state.dialogs[state.folderId]));
      const updatedOneDialog = updatingDialogs.splice(payload.dialogIndex, 1)[0];
      updatedOneDialog.text = payload.text;
      updatedOneDialog.idSender = payload.idProfile;
      updatedOneDialog.idRecipient = payload.idRecipient;
      updatedOneDialog.readStatus = false;
      payload.time && (updatedOneDialog.time = payload.time);
      updatingDialogs.unshift(updatedOneDialog);
      return {
        ...state,
        dialogs: {
          ...state.dialogs,
          [state.folderId]: updatingDialogs
        },
        snippets: mapFromDialogToSnippet(updatingDialogs)
      }
    case actionTypes.SET_SNIPPET_READED:
      const readedSnippets = [...state.snippets]
      const readedSnippetIndex = readedSnippets.findIndex(el => el.lastMessage.idSender === payload)
      if (readedSnippetIndex > -1) {
        readedSnippets[readedSnippetIndex].lastMessage.readStatus = true
      }
      return {
        ...state,
        snippets: readedSnippets
      }
    case actionTypes.SET_MSG_FROM_OTHER_DEVICE:
      if (state.currentUser.id === payload.idUser) {
        const otherDeviceMsgIndex = state.currentMessages.findIndex(el => el.id === payload.idMsg)
        // Своё только что отправленное сообщение ещё может висеть с временным id
        // (Math.random() < 1) до ответа сервера — не дублируем его эхом сокета.
        const hasPendingTwin = state.currentMessages.some(el =>
          typeof el.id === "number" && el.id > 0 && el.id < 1
          && (el.text || "") === (payload.message?.text || "")
          && String(el.idRecipient) === String(payload.message?.idRecipient));
        if (otherDeviceMsgIndex < 0 && !hasPendingTwin) {
          return {
            ...state,
            currentMessages: [...state.currentMessages, payload.message]
          }
        }
        return state
      } else {
        return state
      }
    case actionTypes.UPDATE_LOSTED_MSGS:
      if (payload[payload.length - 1].id === state.currentMessages[state.currentMessages.length - 1].id) {
        return state 
      } else {
        const unLostedMsgs = [...state.currentMessages]
        for (let i = 0; i < payload.length; i++) {
          if (unLostedMsgs.findIndex((elem:messageType) => elem.id === payload[i].id) < 0) {
            unLostedMsgs.push(payload[i])
          } // TODO добавить break для оптимизации
        }
        return {
          ...state,
          currentMessages: unLostedMsgs
        }
      }
    case actionTypes.SET_FOLDER_ID:
      return {
        ...state,
        folderId: payload
      }
    case actionTypes.SET_IS_OPEN_MESSAGES:
      return {
        ...state, isOpenMessages: payload
      }
    case actionTypes.SET_MY_MSG_TEXT:
      return {
        ...state, msgText: payload
      }
    case actionTypes.SET_ERROR_ID_MESSAGES:
      const errorMessages = {
        ...state.errorMessages,
        messagesId: [...state.errorMessages.messagesId, payload]
      }
      return {
        ...state, errorMessages
      }
    case actionTypes.RESET_ERROR_ID_MESSAGES:
      return {
        ...state, errorMessages: {
          ...state.errorMessages, messagesId: []
        }
      }
    case actionTypes.SET_SNIPPET_LOADING:
      return {
        ...state, isLoadingSnippet: payload
      }
    case actionTypes.RESET_MSG_CNT_FOR_CURRENT_DIALOG:
      const cloneDialogs = JSON.parse(JSON.stringify(state.dialogs[state.folderId])).map((dialog: any) => {
        if (dialog.id === payload) {
          const cloneDialog = JSON.parse(JSON.stringify(dialog))
          return {
            ...cloneDialog,
            countUnreadMessages: 0
          }
        } else {
          return dialog
        }
      })
      return  {
        ...state, dialogs: {
          ...state.dialogs,
          [state.folderId]: cloneDialogs
        }
      }
    case actionTypes.SET_LOADING_DIALOGS:
      return  {
        ...state, isLoadingDialogs: payload
      }
    case actionTypes.SET_RESET_MY_MESSAGE:
      return  {
        ...state, isResetMsgText: payload
      }
    case actionTypes.SET_UPDATE_TEXT_LAST_EDITING_MESSAGE_IN_DIALOGS_SIDEBAR:
      const {idUser, newText: updateText} = payload

      return  {
        ...state, dialogs: {
          ...state.dialogs,
            [idFolderAll]: [...state.dialogs[idFolderAll]].map((dialog: dialogType) => {
              if (dialog.id === idUser) {
                return {
                  ...dialog, text: updateText
                }
              } else  {
                return dialog
              }
            })
          }
        }
    case actionTypes.SET_DIALOG_READED:
      return  {
        ...state, dialogs: {
          ...state.dialogs,
          [idFolderAll]: [...state.dialogs[idFolderAll]].map((dialog: dialogType) => {
            if (dialog.idRecipient === payload.idUser) {
              return {
                ...dialog, readStatus: payload.readStatus
              }
            } else  {
              return dialog
            }
          })
        }
      }
    default:
      return state;
  }
};

export default messagesReducer;
